module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.ba3dcd8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.woff
// module id = 320
// module chunks = 1